import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

export const LanguageSwitcher = ({ variant = "default" }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      onClick={toggleLanguage}
      variant={variant}
      size="sm"
      className="flex items-center gap-2 transition-all hover:scale-105"
      title={language === 'en' ? 'Switch to Marathi' : 'Switch to English'}
    >
      <Languages className="w-4 h-4" />
      <span className="font-semibold">{language === 'en' ? 'मराठी' : 'English'}</span>
    </Button>
  );
};
